<div *ngIf="visible" class="scratchCarousel row">
  <div class="scratchCarousel--header">
    <h2><span>{{'scratchcards.play_scratchcards' |translate}}</span></h2>
    <a href="#" [routerLink]="[showLang ? showLang : 'en', 'scratchcards']">{{'scratchcards.show_all_scratchcards' |translate}}</a>
  </div>
  <div class="mw xl-12 md-12 sm-12 xs-12">
    <div class="scratchCarousel--container">
      <owl-carousel *ngIf="itemsSize"
                    [options]="{dotsEach: true, checkVisible: true, stageElement: disable, autoWidth: false, responsiveClass: true, mouseDrag: false, responsive:{
                            '0':{ items:1, nav: false },
                            '555':{ items:2, nav: false },
                            '820':{ items:3, nav: false },
                            '1200':{ items:4, nav: true }
                            }}"
                    [items]="homeScratch"
                    [carouselClasses]="['owl-carousel','owl-theme','owl-drag', 'row']">
        <div class="scratchCarousel--container-item" *ngFor="let item of homeScratch; let i = index">
          <div class="scratchCarousel--container-item-body s_{{item.Items[0].Game.GameID}}">
            <img src="../../../assets/images/scratch/s_{{item.Items[0].Game.GameID}}/half.png"
                *ngIf="item.Items[0].Game.GameID !== 'bichomania' &&
                item.Items[0].Game.GameID !== 'golden_ace' &&
                item.Items[0].Game.GameID !== 'gold_hunt' &&
                item.Items[0].Game.GameID !== 'red_ruby'" />
            <span *ngIf="currency && currency.Code" class="jackpot s_{{item.Items[0].Game.GameID}}">{{ 'home.jackpot' | translate }}: {{item.Rates.TotalJackpotAmount[currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en')}}</span>
          </div>
          <div class="scratchCarousel--container-item-bottom">
            <div class="scratchCarousel--container-item-bottom-counter">
              <div *ngFor="let multi of item.PackageMultiTickets; let x = index" [ngClass]="{'selected': selectedBox[i] == x, 'hasDiscount': item.DiscountAmount[x] > 0 }" class="scratchCarousel--container-item-bottom-counter-item" (click)="pickQuantity(i, x, multi.Tickets)">
                {{multi.Tickets}}
              </div>
            </div>
            <div *ngIf="gamePrice[i] && currency && currency.Code" class="przycisk green medium scratchCarousel--container-item-bottom-payButton {{item.Items[0].Game.GameID}} {{item.ProductType}}" [ngClass]="{'disabled-btn' : isLoadingButtonIndex === i}" (click)="playThisScratch(i, item.PackageID);">

                {{ +gamePrice[i][0] | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en')}}
                <div class="scratchCarousel--container-item-bottom-payButton-lamp"> <img *ngIf="brand === 'qiwi'" src="../../../assets/images/scratch/jinni-lamp.png" /><img *ngIf="brand === 'winaija'" src="../../../assets/images/scratch/cart.png" /></div>
                <span *ngIf="discount[i] > 0"> -{{discount[i]}}% </span>
            </div>
          </div>
        </div>
      </owl-carousel>
    </div>
  </div>
</div>
